import { SubHeader } from './SubHeader';
import { Header as headerImport } from './Header';

export default {
  Major: headerImport,
  Minor: SubHeader,
};
